const listPointsBody = document.querySelector('#UniveralListOfGlobalData').querySelector('div[name=body]');


export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index,nameID) {
    const htmlMeta = ` ${nameID}="${item.id}" elementName="${item.name}"`;
    let available = true;
    let availableHTML = 'available';

    return `
    
    <label class="reference-header cursorPointer w-100" for="${item.id}" ${htmlMeta}>
        <div class="reference-column" ${htmlMeta}>${index + 1}</div>
        <div class="reference-column" ${htmlMeta}>${item.name}</div>
        <div class="reference-column">
          <small action="remove" class="userLblNotActive"  ${htmlMeta}>Удалить</small>
        </div>
        
    </label>`;},

  getAvailableElement(item, index,nameID, modeAvailiable) {
    const htmlMeta = ` ${nameID}="${item.id}" elementName="${item.name}"`;
    let available = true;
    let availableHTML = '';
    if (!modeAvailiable)
      availableHTML = `<small class="userLblActive" action="link"  ${htmlMeta}>Добавить</small> <small action="remove" class="ml-3 userLblNotActive" ${htmlMeta}> Удалить</small>`;
    else
       availableHTML = `<small action="unlink" class="userLblNotActive"  ${htmlMeta}>Отменить</small>`;


    return `
    
    <label class="reference-header cursorPointer w-100" for="${item.id}" ${htmlMeta}>
        <div class="reference-column" ${htmlMeta}>${index + 1}</div>
        <div class="reference-column" ${htmlMeta}>${item.name}</div>
        <div class="reference-column">
          ${availableHTML}
        </div>
        
    </label>`;},

  drawDataInContainer(servData , modeAvailiable, servAnswerFestAvailableData) {
    this.cleanContainer();

    let arrAvailable = [];;
    let arrNotAvailable = [];;

    if (!servData)
        servData = [];
    if (modeAvailiable && servAnswerFestAvailableData) {

        servAnswerFestAvailableData =  servAnswerFestAvailableData.replace('[','').replace(']','').split(',');

      if(servAnswerFestAvailableData && servAnswerFestAvailableData.length > 0){
        servData.forEach((servItem) => {
          let bilo = false;
        
          servAnswerFestAvailableData.forEach((element, index) =>{
              if(servItem.id === parseInt(element))
                bilo = true;
            });

          if (bilo)
            arrAvailable.push(servItem);
          else
            arrNotAvailable.push(servItem);
        });

      } else 
        arrNotAvailable = servData;

      if (arrAvailable) {
        listPointsBody.innerHTML = `
                                  <h4>Доступны на данном фестивале:</h4>
                                  <div class="reference-header firstRow">
                                      <div class="reference-column">№</div>
                                      <div class="reference-column">Название</div>
                                      <div class="reference-column"></div>
                                  </div>`

        arrAvailable.forEach((item, index) => listPointsBody.insertAdjacentHTML('beforeend', this.getAvailableElement(item, index,'elementID', true)));
      }

      if (arrNotAvailable) {
         listPointsBody.innerHTML += `
                                  <h4 class="mt-5">Недоступны на данном фестивале:</h4>
                                  <div class="reference-header w-100 firstRow">
                                      <div class="reference-column">№</div>
                                      <div class="reference-column">Название</div>
                                      <div class="reference-column"></div>
                                  </div>`

        arrNotAvailable.forEach((item, index) => listPointsBody.insertAdjacentHTML('beforeend', this.getAvailableElement(item, index,'elementID'), false));
      }
    } else {

      listPointsBody.innerHTML = `
      <div class="reference-header">
          <div class="reference-column">№</div>
          <div class="reference-column">Название</div>
          ${modeAvailiable ? ' <div class="reference-column">Доступен:</div>' : ''}
      </div>`;

      servData.forEach((item, index) => listPointsBody.insertAdjacentHTML('beforeend', this.getElement(item, index,'elementID')));
    };
  },


  drawDataInContaineInDIV(servData, htmlDiv, attributeKey) {
    htmlDiv.innerHTML = `
    <div class="reference-header w-100">
        <div class="reference-column">№</div>
        <div class="reference-column">Название</div>
       
    </div>
    `;
    servData.forEach((item, index) => htmlDiv.insertAdjacentHTML('beforeend', this.getElement(item, index, attributeKey)));
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },


};
